"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PaymentSummarySpan;

var _react = _interopRequireDefault(require("react"));

function PaymentSummarySpan(props) {
  var title = props.title,
      value = props.value,
      isHighlighted = props.isHighlighted;
  if (!value) return null;
  return _react["default"].createElement("li", null, _react["default"].createElement("span", null, title, ": "), _react["default"].createElement("span", {
    className: isHighlighted ? 'price-hi' : ''
  }, value));
}

PaymentSummarySpan.defaultProps = {
  isHighlighted: false
};